/**
 * Classes de tamanho/espaçamento de texto compartilhadas entre
 * RulesBar.tsx (home) e RulesBarCelebrations.tsx (Black Friday, Natal) —
 * extraídas pra um único lugar depois que um bug de fonte minúscula
 * (text-[8.5px]/text-[7.5px]) apareceu duplicado nos dois arquivos por
 * causa de código copiado (docs/superpowers/specs/2026-08-12-home-fold-crop-fixes-design.md).
 * Cor de texto e fonte continuam definidas localmente em cada componente —
 * só o tamanho/espaçamento é compartilhado.
 */
export const RULES_TEXT_CLASSES =
  "whitespace-nowrap [&>p]:m-0 [&>p:first-child]:text-[11px] [&>p:first-child]:leading-[13px] [&>p:first-child]:font-semibold [&>p:last-child]:text-[9px] [&>p:last-child]:leading-[11px] [&>p:last-child]:mt-[3px]";
